import { useEffect, useState } from "react";
import Packky from "../assets/Packky.png";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setScrollProgress(progress);
    };

    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  return (
    <div className="footer-container " >
      <footer className="footer text-dark position-relative ">
        <div className="container h-100">
          <div className="row ">
            <div className="col-md-4">
              <div className="d-flex justify-content-start" onClick={() => navigate("/")}>
                <img
                  src={Packky}
                  alt="Logo"
                  className="img-fluid mt-4"
                  style={{ maxWidth: "150px", height: "auto" }}
                />
              </div>
              <p className="card-text text-start fs-5 mt-3">
                Order anything and track it in real time with the Packky (powered by Chaafo) app
              </p>
            </div>
            
       
            <div className="col-md-4 mt-4 p-2 d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column text-start">
                <div
                onClick={() => {
                  window.location.href = "/about-us";
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  About Us
                </div>
                <div
                 onClick={() => {
                  window.location.href = "/contact-us";
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Contact Us
                </div>
                <div
                 onClick={() => {
                  window.location.href = '/term-condition';
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Term & Condition
                </div>
                <div
                 onClick={() => {
                  window.location.href = '/privacy-policy';
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Privacy Policy
                </div>
                <div
                 onClick={() => {
                  window.location.href = '/delete-account';
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Delete Account
                </div>
                <div 
                 onClick={() => {
                  window.location.href = '/blog-section';
                }}
                  className="text-dark text-decoration-none mb-2 fs-6"
                  style={{
                    transition: "color 0.3s ease",
                    fontFamily: "SF Pro Display, sans-serif",
                  }}
                >
                  Blog
                </div>
              </div>
            </div>

            <div className="col-md-4 d-flex justify-content-md-end justify-content-center mt-3">
              <div className="social-icons mt-5 d-flex">
               <div 
                 onClick={() => {
                  window.location.href = 'https://www.instagram.com/packkyofficials/';
                }}
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram fs-2"></i>
                </div>

              <div 
                 onClick={() => {
                  window.location.href = 'https://www.facebook.com/';
                }}
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f fs-2"></i>
                </div>

                <div
                 onClick={() => {
                  window.location.href = 'https://x.com/Packkyofficials';
                }}
                  className="me-3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-twitter fs-2"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center">
            <p className="card-text text-center fs-6 ">
              Packky (powered by Chaafo) © 2024 . All rights reserved.
            </p>
          </div>

          <div
            className="btn btn-black rounded-circle aero-btn position-fixed d-flex justify-content-center align-items-center progress-circle"
            style={{
              bottom: "15px",
              right: "20px",
              width: "50px",
              height: "50px",
              zIndex: "1000",
              "--progress": `${scrollProgress}%`,
            }}
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
              navigate("/")
            }}
          >
            <i className="fa-solid fa-arrow-up fs-3"></i>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;

